import {Tag, Typography} from "antd";

function TextCopy({value, style = {}}) {
    return (
        <Typography.Paragraph
            copyable={{
                text: value
            }}
            style={{
                margin: 0,
                ...style
            }}
        >
            <Tag style={{ 
                maxWidth: '100%', 
                overflow: 'hidden', 
                textOverflow: 'ellipsis',
                whiteSpace: 'nowrap',
                display: 'inline-block'
            }}>
                {value}
            </Tag>
        </Typography.Paragraph>
    )
}

export default TextCopy;
